/** Grid column count per SPEC §6.3: 1 below 640px, 2 from 640, 3 from 1024, 4 from 1440. */
export const COLUMN_BREAKPOINTS = [640, 1024, 1440] as const;

export function columnsForWidth(width: number): number {
  return 1 + COLUMN_BREAKPOINTS.filter((min) => width >= min).length;
}

/** Live column count from media queries (matches the CSS breakpoints exactly). */
export class ColumnCount {
  value: number;
  readonly #queries: MediaQueryList[];
  readonly #update = () => {
    this.value = 1 + this.#queries.filter((query) => query.matches).length;
  };

  constructor(
    win: Pick<Window, 'matchMedia'> | null = typeof window === 'undefined' ? null : window,
  ) {
    this.#queries =
      typeof win?.matchMedia === 'function'
        ? COLUMN_BREAKPOINTS.map((min) => win.matchMedia(`(min-width: ${String(min)}px)`))
        : [];
    this.value = $state(1 + this.#queries.filter((query) => query.matches).length);
    for (const query of this.#queries) query.addEventListener('change', this.#update);
  }

  destroy(): void {
    for (const query of this.#queries) query.removeEventListener('change', this.#update);
  }
}
